/* WebMCP tools for connecteninternet.com. Read-only; each tool wraps a public Shopify storefront endpoint. */
(function () {
  var mc = (document.modelContext && document.modelContext.registerTool) ? document.modelContext
    : (navigator.modelContext && navigator.modelContext.registerTool) ? navigator.modelContext : null;
  if (!mc) return;

  var PLAN_HANDLES = [
    'netrifi-single-carrier-home-internet-plan',
    'netrifi-smart-vsim',
    'netrifi-business-internet-plan',
    'connecten-failover-internet'
  ];

  function text(obj) {
    return { content: [{ type: 'text', text: typeof obj === 'string' ? obj : JSON.stringify(obj) }] };
  }
  function getJson(url) {
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error('Request failed: ' + r.status);
      return r.json();
    });
  }
  function dollars(cents) { return (cents / 100).toFixed(2); }

  mc.registerTool({
    name: 'connecten_search_products',
    description: 'Search ConnecTen internet products and plans by keyword. Returns title, URL and starting price.',
    inputSchema: {
      type: 'object',
      properties: {
        query: { type: 'string', description: 'Search keywords, e.g. "business failover" or "travel plan".' },
        limit: { type: 'integer', minimum: 1, maximum: 10, description: 'Maximum results (default 5).' }
      },
      required: ['query']
    },
    annotations: { readOnlyHint: true },
    execute: function (args) {
      var limit = Math.min(Math.max(parseInt(args.limit, 10) || 5, 1), 10);
      var url = '/search/suggest.json?q=' + encodeURIComponent(args.query) +
        '&resources[type]=product&resources[limit]=' + limit;
      return getJson(url).then(function (d) {
        var items = (d.resources && d.resources.results && d.resources.results.products) || [];
        return text(items.map(function (p) {
          return { title: p.title, url: location.origin + p.url, price: p.price, available: p.available };
        }));
      });
    }
  });

  mc.registerTool({
    name: 'connecten_get_plan_pricing',
    description: 'Get current monthly pricing and variants for the main ConnecTen internet plans (home, travel, business, failover). Prices are in USD.',
    inputSchema: { type: 'object', properties: {} },
    annotations: { readOnlyHint: true },
    execute: function () {
      return Promise.all(PLAN_HANDLES.map(function (h) { return getJson('/products/' + h + '.js'); })).then(function (products) {
        return text(products.map(function (p) {
          return {
            title: p.title,
            url: location.origin + p.url,
            variants: p.variants.map(function (v) { return { title: v.title, price_usd: dollars(v.price), available: v.available }; })
          };
        }));
      });
    }
  });

  mc.registerTool({
    name: 'connecten_get_cart',
    description: 'Read the current browser session cart: items, quantities and total in USD. Does not modify the cart.',
    inputSchema: { type: 'object', properties: {} },
    annotations: { readOnlyHint: true },
    execute: function () {
      return getJson('/cart.js').then(function (c) {
        return text({
          item_count: c.item_count,
          total_usd: dollars(c.total_price),
          items: c.items.map(function (i) { return { title: i.title, quantity: i.quantity, line_price_usd: dollars(i.final_line_price), url: location.origin + i.url }; }),
          checkout_url: location.origin + '/checkout'
        });
      });
    }
  });

  mc.registerTool({
    name: 'connecten_get_contact_info',
    description: 'Get ConnecTen internet support and sales contact details and key policy links.',
    inputSchema: { type: 'object', properties: {} },
    annotations: { readOnlyHint: true },
    execute: function () {
      return text({
        support_email: 'support@connecteninternet.com',
        contact_page: location.origin + '/pages/business-contact',
        help_center: location.origin + '/pages/help-center',
        faq: location.origin + '/pages/faq',
        coverage: location.origin + '/pages/coverage',
        refund_policy: location.origin + '/policies/refund-policy',
        agent_instructions: location.origin + '/agents.md'
      });
    }
  });
})();
